<template>
    <div class="input-block">
        <label :for="forId" class="label">{{ labelName }}</label>
        <input
            class="simple-input"
            :id="forId"
            :name="forId"
            :type="type ? type : 'text'"
            v-model="modelValue"
            @input="valueChanged(modelValue)"
            :placeholder="placeholder"
        />
        <div class="error-message" v-if="error">{{ error }}</div>
    </div>
</template>

<script>
export default {
    name: 'SimpleInputField',
    data() {
        return {
            modelValue: null,
        }
    },
    props: ['labelName', 'forId', 'initialValue', 'type', 'placeholder', 'error'],
    watch: {
        $props: {
            handler() {
                this.checkProps()
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        this.checkProps()
    },
    methods: {
        checkProps() {
            if (this.initialValue) {
                this.modelValue = this.initialValue
            }
        },
        valueChanged(val) {
            this.$emit('input', val)
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../../../../../assets/scss/global-styles';

.input-block {
    padding: 10px 20px;
    position: relative;
    display: flex;
    flex-direction: column;

    &:hover,
    &:active {
        background: rgba(192, 192, 201, 0.12) 0% 0% no-repeat padding-box;
        border-radius: 6px;
    }

    .label {
        font-family: 'Gilroy-Regular', sans-serif;
        font-size: 12px;
        line-height: 14px;
        text-align: left;
        color: $mainTextBlueColor;
    }

    .simple-input {
        background: transparent;
        border: none;
        color: $mainTextBlueColor;
        padding: 10px 10px 10px 0;
        font-family: 'Gilroy-SemiBold', sans-serif;
        font-size: 18px;
        line-height: 22px;
        text-align: left;
        outline: none;
        margin-right: 10px;

        &:hover {
            border-radius: 6px;
        }

        &::placeholder {
            font-family: 'Gilroy-SemiBold', sans-serif;
            font-size: 18px;
            line-height: 22px;
            text-align: left;
            color: $mainTextBlueColor;
        }
    }

    .error-message {
        font-family: 'Gilroy-Regular', sans-serif;
        font-size: 12px;
        line-height: 12px;
        letter-spacing: 0.4px;
        color: $mainErrorColor;
        position: absolute;
        bottom: 0;
        left: 20px;
        animation-name: errorHandle;
        animation-duration: 0.5s;
    }

    @keyframes errorHandle {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
}

@media (max-width: 768px) {
    .form-body {
        padding: 10px 10px 20px;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: flex-start;

        .submit-button {
            margin: 40px auto 0;
        }

        .input-block {
            max-width: unset;
            padding: 10px 20px;
            flex-basis: unset;

            .label {
                font-size: 14px;
                line-height: 17px;
            }

            .error-message {
                left: 10px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/shared/forms_entities/form-fields/SimpleInputField.vue